var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStep2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2F32",
  d: "M54.688 7A5.688 5.688 0 1 1 49 1.313 5.695 5.695 0 0 1 54.688 7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2F32",
  d: "M12 6.5h32v1H12z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00685E",
  d: "M7 1.313a5.687 5.687 0 1 0 0 11.374A5.687 5.687 0 0 0 7 1.313m2.497 4.684L6.435 9.06a.437.437 0 0 1-.62 0L4.503 7.747a.438.438 0 0 1 .619-.619l1.003 1.003 2.753-2.753a.438.438 0 0 1 .619.619"
})));
export default SvgStep2;